import React from "react";
import { Translate } from "react-localize-redux";

const RatingTable = ({ data, desc, has10StarPermission }) => {
    return (
        <React.Fragment>
            {data &&
                <>
                    <table className="table table-report-section key-value w-100">
                        <colgroup>
                            <col width="50%" />
                            <col width="50%" />
                        </colgroup>
                        <tbody>
                            {((has10StarPermission && data.tenStarRating) || (!has10StarPermission && data.risk)) &&
                                <tr>
                                    <td style={{ fontWeight: "bold" }}><Translate id="Report.Ratings.Risk" /></td>
                                    {has10StarPermission && <td><Translate id={`Report.Ratings.10Star.${data.tenStarRating}`} /></td>}
                                    {!has10StarPermission && <td><Translate id={`Report.Ratings.Evaluation.${data.risk}`} /></td>}
                                </tr>
                            }
                            {data.fs &&
                                <tr>
                                    <td style={{ fontWeight: "bold" }}><Translate id="Report.Ratings.FinancialCondition" /></td>
                                    <td>{data.fs}</td>
                                </tr>
                            }
                            {data.gr &&
                                <tr>
                                    <td style={{ fontWeight: "bold" }}><Translate id="Report.Ratings.EconomicGroup" /></td>
                                    <td>{data.gr}</td>
                                </tr>
                            }
                            {data.ir &&
                                <tr>
                                    <td style={{ fontWeight: "bold" }}><Translate id="Report.Ratings.IndustryEvaluation" /></td>
                                    <td><Translate id={`Report.Ratings.Industry.Evaluation.${data.ir}`} /></td>
                                </tr>
                            }
                            {data.rr &&
                                <tr>
                                    <td style={{ fontWeight: "bold" }}><Translate id="Report.Ratings.RegionEvaluation" /></td>
                                    <td>{data.rr}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    {(desc !== "" || data.unavailabilityDesc !== "") &&
                        <table className="table old-style-table-report w-100">
                            <thead>
                                <tr>
                                    <th><Translate id="Report.Ratings.Comment" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                {desc !== "" && <tr><td>{desc}</td></tr>}
                                {data.unavailabilityDesc !== "" && <tr><td>{data.unavailabilityDesc}</td></tr>}
                            </tbody>
                        </table>}
                </>
            }
        </React.Fragment>
    )
}

export default RatingTable;